"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var contract_const_1 = require("@const/contract.const");
var input_output_helper_const_1 = require("@const/input-output-helper.const");
var input_mapping_const_1 = require("@const/input.mapping.const");
var lead_service_1 = require("@services/lead.service");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var aov_helper_const_1 = require("@src/const/aov-helper.const");
var error_helper_const_1 = require("@src/const/error-handling/error-helper.const");
var helper_const_1 = require("@src/const/helper.const");
var input_output_module_const_1 = require("@src/const/input-output-module.const");
var notes_helper_const_1 = require("@src/const/notes-helper.const");
var fitpay_payment_options_const_1 = require("@src/modules/fitpay/const/fitpay-payment-options.const");
var validate_dynamic_checkboxes_1 = require("@src/modules/shared/validation/validate-dynamic-checkboxes");
var ci_component_injector_service_1 = require("@src/services/ci-component-injector.service");
var frontend_error_logger_service_1 = require("@src/services/frontend-error-logger.service");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var module_handler_service_1 = require("@src/services/module-handler.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var variables_const_1 = require("@src/variables.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var manychat_api_1 = require("../../../api/manychat.api");
var sendcloud_welcomebox_1 = require("../../../api/sendcloud-welcomebox");
var element_generator_1 = require("../../../element-generator");
var fitpay_bank_account_helper_1 = require("../../fitpay/fitpay-bank-account.helper");
var price_preview_1 = require("../price-preview/price-preview");
var form_const_1 = require("./const/form.const");
var validate_const_1 = require("./const/validate.const");
var event_listeners_1 = require("./event-listeners");
var payment_choice_1 = require("./payment-choice");
var perform_onboarding_1 = require("./perform-onboarding");
var contract_preview_service_1 = require("./services/contract-preview.service");
var magicline_payment_service_1 = require("./services/magicline-payment.service");
var send_email_service_1 = require("./services/send-email.service");
var yond_finish_service_1 = require("./services/yond-finish.service");
var voucher_code_const_1 = require("./voucher-code.const");
var iban_1 = require("@src/const/forms/iban");
var tracker_service_1 = require("@src/services/tracker.service");
var api_helper_const_1 = require("@src/const/api-helper.const");
var Form = /** @class */ (function () {
    function Form() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.leadService = object_service_1.ObjectService.getInstance(lead_service_1.LeadService);
        this.elementGenerator = object_service_1.ObjectService.getInstance(element_generator_1.ElementGenerator);
        this.sendEmailService = object_service_1.ObjectService.getInstance(send_email_service_1.SendEmailService);
        //private stripePayment = ObjectService.getInstance(StripePayment);
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.yondFinishService = object_service_1.ObjectService.getInstance(yond_finish_service_1.YondFinishService);
        this.trackerService = object_service_1.ObjectService.getInstance(tracker_service_1.TrackerService);
        this.createCustomerLoading = false;
        this.mlCreationWasSuccessful = false;
    }
    Form.prototype.validateModule = function () {
        return __awaiter(this, arguments, void 0, function (options, readFromStorage) {
            var formMappings, _a, paymentChoice, validPaymentChoice, requiresBankAccount, hasMagiclinePaymentElement, allData, taxId, testVoucher, validationResult, ibanLen;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
            if (options === void 0) { options = { showErrors: true }; }
            if (readFromStorage === void 0) { readFromStorage = false; }
            return __generator(this, function (_9) {
                switch (_9.label) {
                    case 0:
                        formMappings = lodash_1.default.cloneDeep((_b = options.mappings) !== null && _b !== void 0 ? _b : input_mapping_const_1._AllMappings);
                        _a = (0, payment_choice_1.validateMembershipPaymentChoice)(this.$container, options), paymentChoice = _a.paymentChoice, validPaymentChoice = _a.valid, requiresBankAccount = _a.requiresBankAccount;
                        hasMagiclinePaymentElement = (_c = magicline_payment_service_1.MagiclinePaymentService.isEnabledForStudio(this.config)) !== null && _c !== void 0 ? _c : (((_g = (_f = (_e = (_d = this.module) === null || _d === void 0 ? void 0 : _d.references) === null || _e === void 0 ? void 0 : _e.magiclinePaymentsElementRecuring) === null || _f === void 0 ? void 0 : _f.domElement) === null || _g === void 0 ? void 0 : _g.length) === 1 ||
                            ((_l = (_k = (_j = (_h = this.module) === null || _h === void 0 ? void 0 : _h.references) === null || _j === void 0 ? void 0 : _j.magiclinePaymentsElementUpfront) === null || _k === void 0 ? void 0 : _k.domElement) === null || _l === void 0 ? void 0 : _l.length) === 1);
                        //show errors in birthdaymodule after first try sending module
                        // this.birthdayModule.settings.showErrors = true;
                        // this.birthdayModule.validateModule();
                        if (!requiresBankAccount ||
                            (((_m = this.stripePaymentElement) === null || _m === void 0 ? void 0 : _m.magiclinePaymentChoice) === 'STRIPE' && ((_o = this.stripePaymentElement) === null || _o === void 0 ? void 0 : _o.fitpayEnabled)) ||
                            hasMagiclinePaymentElement) {
                            // Bank details are only required for direct debit without a payment widget.
                            formMappings = (0, input_output_helper_const_1._FilterMappingsBasedOnFields)(formMappings, __assign({}, input_mapping_const_1._BankAccountMapping));
                            // remove error on consent if exists as it will stay if its not validated again due to it being removed, shouldnt matter if moved inside SEPA payment tab
                            (0, error_helper_const_1._RemoveStatusFromDomObject)((0, input_output_helper_const_1._GetFieldDomObj)(input_mapping_const_1._AllMappings.consent, this.$container));
                        }
                        if (this.birthdayModule.settings.underAgeContracts && this.birthdayModule.age < this.birthdayModule.settings.matureAge) {
                            //IBAN IS optional as most minors do not know the banking infos of their parents
                            formMappings = (0, input_output_helper_const_1._FilterMappingsBasedOnFields)(formMappings, __assign({}, input_mapping_const_1._BankAccountMapping));
                            // remove error on consent if exists as it will stay if its not validated again due to it being removed, shouldnt matter if moved inside SEPA payment tab
                            (0, error_helper_const_1._RemoveStatusFromDomObject)((0, input_output_helper_const_1._GetFieldDomObj)(input_mapping_const_1._AllMappings.consent, this.$container));
                        }
                        if (!readFromStorage) {
                            console.log('reading fields', formMappings, options);
                            allData = (0, input_output_module_const_1.ValidateFieldsInModule)(this, __assign(__assign({}, options), { mappings: formMappings }), true);
                            console.log('data res', allData);
                        }
                        else {
                            // used for external payment redirects
                            allData = { data: (0, input_output_helper_const_1._ReadAllFields)(formMappings) };
                        }
                        allData.data.customer.countryCode =
                            (_p = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.countryCode)) !== null && _p !== void 0 ? _p : input_mapping_const_1._AllMappings.countryCode.defaultValue;
                        allData.data.studioName = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.studioName);
                        allData.data.membershipName = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.rateBundleName);
                        taxId = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.taxId);
                        if ((taxId === null || taxId === void 0 ? void 0 : taxId.length) && allData.data.customer && !((_s = (_r = (_q = allData.data) === null || _q === void 0 ? void 0 : _q.customer) === null || _r === void 0 ? void 0 : _r.taxId) === null || _s === void 0 ? void 0 : _s.length)) {
                            allData.data.customer.taxId = taxId;
                        }
                        //Base contract includes modules, startdate, ratebundle etc
                        allData.data.contract = (0, contract_const_1._CreateBaseContract)();
                        // TODO: Workaround for string termIds
                        if (this.config.get.technologyType === 'themisoft') {
                            allData.data.contract.rateBundleTermId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.rateBundleTermId);
                        }
                        // Only an explicit payment-choice field can override the direct-debit default.
                        lodash_1.default.set(allData, 'data.customer.paymentChoice', paymentChoice);
                        if (!validPaymentChoice)
                            allData.valid = false;
                        localStorage.setItem('paymentTechnology', ((_t = this.stripePaymentElement) === null || _t === void 0 ? void 0 : _t.magiclinePaymentChoice) || 'DIRECT_DEBIT');
                        if (((_u = this.stripePaymentElement) === null || _u === void 0 ? void 0 : _u.magiclinePaymentChoice) === 'STRIPE' && ((_v = this.stripePaymentElement) === null || _v === void 0 ? void 0 : _v.fitpayEnabled)) {
                            //fake data to satisfy Magicline if paid via
                            console.log('fitpay enabled, using fake bank details');
                            (0, fitpay_bank_account_helper_1.setFitPayBankAccountDummy)(this.config, allData);
                        }
                        else {
                            console.log('fitpay is disabled', (_w = this.stripePaymentElement) === null || _w === void 0 ? void 0 : _w.magiclinePaymentChoice, (_x = this.stripePaymentElement) === null || _x === void 0 ? void 0 : _x.fitpayEnabled);
                        }
                        if (!requiresBankAccount)
                            delete allData.data.customer.bankAccount;
                        // workaround for string studioIDs :/
                        if (this.config.get.technologyType === 'themisoft' || this.config.get.technologyType === 'yond') {
                            allData.data.studioId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                        }
                        else {
                            allData.data.studioId = +(0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                        }
                        return [4 /*yield*/, (0, voucher_code_const_1._TestVoucherCode)(this.$container)];
                    case 1:
                        testVoucher = _9.sent();
                        if (testVoucher.valid) {
                            allData.data.voucherCode = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.voucherCode);
                        }
                        else {
                            allData.data.voucherCode = '';
                        }
                        validationResult = this.birthdayModule.validateAll(true);
                        console.log('Birthday result', validationResult);
                        if (validationResult.valid) {
                            if (validationResult.valid && ((_y = validationResult === null || validationResult === void 0 ? void 0 : validationResult.data) === null || _y === void 0 ? void 0 : _y.age) && ((_z = validationResult === null || validationResult === void 0 ? void 0 : validationResult.data) === null || _z === void 0 ? void 0 : _z.birthday)) {
                                (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._BirthdayForm.age, validationResult.data.age);
                                (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._BirthdayForm.dateOfBirth, validationResult.data.birthday);
                                allData.data.customer.dateOfBirth = validationResult.data.birthday;
                            }
                            else {
                                (0, input_output_helper_const_1._RemoveFieldFromLocalstorage)(input_mapping_const_1._BirthdayForm.age);
                                (0, input_output_helper_const_1._RemoveFieldFromLocalstorage)(input_mapping_const_1._BirthdayForm.dateOfBirth);
                            }
                            if ((_0 = validationResult === null || validationResult === void 0 ? void 0 : validationResult.data) === null || _0 === void 0 ? void 0 : _0.guardian) {
                                this.guardian = validationResult.data.guardian;
                                // save for fitbuy returning from external payment
                                localStorage.setItem('guardianData', JSON.stringify(this.guardian));
                            }
                        }
                        else {
                            console.warn('Birthday is invalid');
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidBirthday'));
                            allData.valid = false;
                        }
                        // allData.data.customer.dateOfBirth = _ReadFieldFromLocalstorage(_BirthdayForm.dateOfBirth);
                        // IBAN remove spaces and dashes
                        if (requiresBankAccount && !hasMagiclinePaymentElement) {
                            if ((_4 = (_3 = (_2 = (_1 = allData.data) === null || _1 === void 0 ? void 0 : _1.customer) === null || _2 === void 0 ? void 0 : _2.bankAccount) === null || _3 === void 0 ? void 0 : _3.iban) === null || _4 === void 0 ? void 0 : _4.length) {
                                allData.data.customer.bankAccount.iban = allData.data.customer.bankAccount.iban.replace(/[\s-]/g, '');
                            }
                            if (this.birthdayModule.settings.underAgeContracts && this.birthdayModule.age < this.birthdayModule.settings.matureAge) {
                                //minors do not need to know the IBAN of their parents
                            }
                            else {
                                ibanLen = (_8 = (_7 = (_6 = (_5 = allData.data) === null || _5 === void 0 ? void 0 : _5.customer) === null || _6 === void 0 ? void 0 : _6.bankAccount) === null || _7 === void 0 ? void 0 : _7.iban) === null || _8 === void 0 ? void 0 : _8.length;
                                if (!ibanLen || ibanLen < 15 || ibanLen > 34) {
                                    (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('The IBAN has to be between 15 and 34 characters'));
                                    console.warn('Iban is invalid');
                                    allData.valid = false;
                                }
                            }
                        }
                        return [4 /*yield*/, this.offlineFMS(allData)];
                    case 2:
                        allData = _9.sent();
                        console.log('ALL DATA', allData);
                        return [2 /*return*/, allData];
                }
            });
        });
    };
    Form.prototype.offlineFMS = function (customerValidation) {
        return __awaiter(this, void 0, void 0, function () {
            var offerings, startDateValidation, noteData, oldNotes;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.offlineFMS)) return [3 /*break*/, 2];
                        console.log('Using offline fms validation');
                        return [4 /*yield*/, (0, api_helper_const_1._GetOfferings)()];
                    case 1:
                        offerings = _h.sent();
                        startDateValidation = (0, contract_const_1._ValidateOfflineFunnelStartDate)(customerValidation.data.contract, offerings);
                        if (startDateValidation === false)
                            customerValidation.valid = false;
                        noteData = (0, input_output_helper_const_1._ValidateAnyField)(this.$container, input_mapping_const_1._Notes);
                        if (noteData.valid) {
                            oldNotes = ((_d = (_c = customerValidation === null || customerValidation === void 0 ? void 0 : customerValidation.data) === null || _c === void 0 ? void 0 : _c.contract) === null || _d === void 0 ? void 0 : _d.notes) || '';
                            if ((_g = (_f = (_e = noteData === null || noteData === void 0 ? void 0 : noteData.data) === null || _e === void 0 ? void 0 : _e.contract) === null || _f === void 0 ? void 0 : _f.notes) === null || _g === void 0 ? void 0 : _g.length) {
                                customerValidation.data.contract.notes = (oldNotes === null || oldNotes === void 0 ? void 0 : oldNotes.length)
                                    ? oldNotes + noteData.data.contract.notes
                                    : noteData.data.contract.notes;
                            }
                        }
                        _h.label = 2;
                    case 2: 
                    //no offline fms is always valid (no extra fields required)
                    return [2 /*return*/, customerValidation];
                }
            });
        });
    };
    Form.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, ibanField, pricePreview, taxField, country, signFieldContainer, signField;
            var _this = this;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            return __generator(this, function (_s) {
                switch (_s.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, (0, module_handler_service_1._BootstrapModuleIfNoChildModule)(this.$container, 'birthday')];
                    case 1:
                        _a.birthdayModule = (_s.sent()).instance;
                        (0, input_output_helper_const_1._PrefillFields)(this.$container);
                        (0, input_output_helper_const_1._PrefillHiddenFields)();
                        if (this.config.get.environment === 'dev') {
                            // _PrefillDevFields(this.$container);
                            //_DemoPrefillStudioAndContractStep()
                        }
                        (0, notes_helper_const_1.addConfigNotes)((_c = (_b = this.config.get) === null || _b === void 0 ? void 0 : _b.finish) === null || _c === void 0 ? void 0 : _c.notes);
                        object_service_1.ObjectService.getInstance(event_listeners_1.EventListeners).$container = this.$container;
                        object_service_1.ObjectService.getInstance(event_listeners_1.EventListeners).addEvents();
                        this.elementGenerator.createElements();
                        ibanField = (0, input_output_helper_const_1._GetFieldDomObj)(input_mapping_const_1._BankAccountMapping.iban, this.$container);
                        if (ibanField.length) {
                            //TODO: LISTEN TO THE VALIDATION RIGHT NOW WE JUST DO IT BACKEND NOT
                            (0, iban_1._AddSmartValidationToIBAN)(ibanField);
                        }
                        (0, payment_choice_1.initMembershipPaymentChoice)(this.$container);
                        // payment intent failed
                        this.communicationService.subscribeChildren(this).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var captchaRes;
                            var _a, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        if (data.event === 'loaded' && ((_a = data.module) === null || _a === void 0 ? void 0 : _a.moduleKey) === 'fitpay-payment-element') {
                                            // get stripe payment instance ref and check for failed returned payment
                                            this.stripePaymentElement = data.module.module.instance;
                                        }
                                        if (!(data.event === 'custom' && data.name === 'externalPaymentProviderCallback')) return [3 /*break*/, 4];
                                        if (!(data.value === true)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.clickWebflowButton()];
                                    case 1:
                                        _d.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        this.createCustomerLoading = false;
                                        _d.label = 3;
                                    case 3: return [3 /*break*/, 11];
                                    case 4:
                                        if (!(data.event === 'custom' && data.name === 'loadingFinishedCallback')) return [3 /*break*/, 5];
                                        return [3 /*break*/, 11];
                                    case 5:
                                        if (!(data.event === 'custom' && data.name === 'disableFitpay')) return [3 /*break*/, 6];
                                        // payment intent failed, remove payment options and show error
                                        console.warn('fitpay payment intent failed, potentially invalid product, removing fitpay options!');
                                        if ((_b = this.module.references) === null || _b === void 0 ? void 0 : _b.fitpayPaymentSwitcher.domElement) {
                                            (0, fitpay_payment_options_const_1._RemoveFitpayPaymentOptions)();
                                        }
                                        return [3 /*break*/, 11];
                                    case 6:
                                        if (!(data.event === 'custom' && data.name === 'handledReturningPaymentCallback')) return [3 /*break*/, 10];
                                        // callback from fitpay if we returned from callback from klarna
                                        console.log('handing returning payment, success:', data.value);
                                        if (!(data.value === true)) return [3 /*break*/, 8];
                                        this.createCustomerLoading = true;
                                        captchaRes = this.$container.find("#g-recaptcha-response");
                                        if (captchaRes.length) {
                                            captchaRes.remove();
                                        }
                                        return [4 /*yield*/, this.clickWebflowButton()];
                                    case 7:
                                        _d.sent();
                                        return [3 /*break*/, 9];
                                    case 8:
                                        this.createCustomerLoading = false;
                                        _d.label = 9;
                                    case 9: return [3 /*break*/, 11];
                                    case 10:
                                        if (data.event === 'custom' && data.name === 'expressValidationFailed') {
                                            // express checkout was successful, but additional data is required
                                            // remove the payment elements to not confuse the customer
                                            (0, fitpay_payment_options_const_1._RemoveAllPaymentOptions)((_c = this.module) === null || _c === void 0 ? void 0 : _c.references);
                                        }
                                        _d.label = 11;
                                    case 11: return [2 /*return*/];
                                }
                            });
                        }); });
                        this.communicationService.subscribeGlobally().subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b, _c, _d, _e, _f;
                            return __generator(this, function (_g) {
                                switch (_g.label) {
                                    case 0:
                                        if (!(data.event === 'custom' &&
                                            (data.name === 'membershipSelected' ||
                                                (data.name === 'studioSelected' && ((_b = (_a = this.config.get.magiclinePayments) === null || _a === void 0 ? void 0 : _a.studioIds) === null || _b === void 0 ? void 0 : _b.length))))) return [3 /*break*/, 2];
                                        console.log('membership changed, reloading ml payments');
                                        return [4 /*yield*/, magicline_payment_service_1.MagiclinePaymentService.initMagiclinePayments((_d = (_c = this.module.references) === null || _c === void 0 ? void 0 : _c.magiclinePaymentsElementRecuring) === null || _d === void 0 ? void 0 : _d.domElement, (_f = (_e = this.module.references) === null || _e === void 0 ? void 0 : _e.magiclinePaymentsElementUpfront) === null || _f === void 0 ? void 0 : _f.domElement, this.config)];
                                    case 1:
                                        _g.sent();
                                        _g.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        console.log('module', this.module, 'refs', this.module.references);
                        (_e = (_d = this.module.references.membershipComplete) === null || _d === void 0 ? void 0 : _d.domElement) === null || _e === void 0 ? void 0 : _e.on('click', function (event) {
                            console.log('submit!!!');
                            event.preventDefault();
                            _this.sendForm();
                        });
                        if (!((_f = this.module.references.membershipComplete) === null || _f === void 0 ? void 0 : _f.domElement)) {
                            console.warn('No membership complete button found!');
                        }
                        // prevent enter submit of the form, or any other indirect submitions
                        if ((_g = this.module.references.webflowSubmit) === null || _g === void 0 ? void 0 : _g.domElement) {
                            this.membershipFormElement = this.module.references.webflowSubmit.domElement.closest('form');
                            (0, input_output_helper_const_1._OverwriteIndirectFormSubmit)(this.membershipFormElement, function () {
                                _this.sendForm();
                            });
                        }
                        else {
                            console.warn('No webflow submit button found!');
                        }
                        // this.$container.find('[data-action="submit"]').on('click', async () => {
                        //   console.log("submit???")
                        //   await this.sendForm();
                        // });
                        if (this.config.get.environment === 'dev') {
                            console.log('Perform load module');
                        }
                        this.prepareForm();
                        if (!this.config.get.legacy) {
                            this.disableHiddenFields();
                        }
                        if (((_j = (_h = this.config) === null || _h === void 0 ? void 0 : _h.get) === null || _j === void 0 ? void 0 : _j.technologyType) === 'yond') {
                            this.yondFinishService.handleYondFinish(this.$container, true);
                        }
                        // TODO: remove legacy price preview compability
                        if (this.$container.find(variables_const_1.PRICEOVERVIEWID).length > 0) {
                            pricePreview = object_service_1.ObjectService.getInstance(price_preview_1.PricePreview);
                            pricePreview.$container = this.$container.find(variables_const_1.PRICEOVERVIEWID);
                            pricePreview.loadModule();
                        }
                        taxField = this.$container.find("[data-get=\"".concat(input_mapping_const_1._AllMappings.taxId.uid, "\"]"));
                        if (taxField.length) {
                            country = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.studioCountryCode);
                            //console.log("studio country", country, "included?", ["PR", "ES", "IT"].includes(country))
                            if (!['PT', 'ES', 'IT'].includes(country)) {
                                taxField.remove();
                            }
                        }
                        signFieldContainer = (_k = this.module.references.signField) === null || _k === void 0 ? void 0 : _k.domElement;
                        if (signFieldContainer === null || signFieldContainer === void 0 ? void 0 : signFieldContainer.length) {
                            // load ci-components
                            (0, ci_component_injector_service_1._InjectStencilWebComponents)();
                            signField = (0, cash_dom_1.default)("<ci-sign-field clear-button=\"false\"></ci-sign-field>");
                            signFieldContainer.append(signField);
                        }
                        // 2. Set up button handler
                        (_m = (_l = this.module.references.signFieldClearButton) === null || _l === void 0 ? void 0 : _l.domElement) === null || _m === void 0 ? void 0 : _m.on('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var signFieldEl;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        console.log('clear sign field');
                                        event.preventDefault();
                                        signFieldEl = document.querySelector('ci-sign-field');
                                        if (!(signFieldEl && typeof signFieldEl.clearSignField === 'function')) return [3 /*break*/, 2];
                                        return [4 /*yield*/, signFieldEl.clearSignField()];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        console.warn('Sign field element not ready or clearSignField not available');
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        // magicline payments integration
                        return [4 /*yield*/, magicline_payment_service_1.MagiclinePaymentService.initMagiclinePayments((_p = (_o = this.module.references) === null || _o === void 0 ? void 0 : _o.magiclinePaymentsElementRecuring) === null || _p === void 0 ? void 0 : _p.domElement, (_r = (_q = this.module.references) === null || _q === void 0 ? void 0 : _q.magiclinePaymentsElementUpfront) === null || _r === void 0 ? void 0 : _r.domElement, this.config)];
                    case 2:
                        // magicline payments integration
                        _s.sent();
                        // contract preview
                        contract_preview_service_1.ContractPreviewService.initElement(this, this.config);
                        return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.prepareForm = function () {
        (0, generator_const_1._HideErrorMessage)();
        (0, error_helper_const_1._HideSuccessMessage)();
        (0, helper_const_1._ScrollToTop)(0);
        if (!localStorage.getItem(form_const_1.MAPPINGS.location.localStorageKey) && this.config.get.legacy === false) {
            if (this.config.get.environment === 'prod') {
                window.location.replace('/membership/checkout');
            }
            else {
                console.error('NOTICE: on production script you would be now redirected to checkout since the location is not set in localstorage');
            }
        }
        // this.$container
        //   .find(MAPPINGS.submitButton.id)
        //   .on('click', async (event: Event) => {
        //     console.log("submit!!!")
        //     event.preventDefault();
        //     this.sendForm();
        //   });
    };
    Form.prototype.sendForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var form, formData, formVal, hasMagiclinePaymentElement, hasNonSepaPaymentChoice, ignoredPaymentConsent, signFieldEl, time, data, recaptchaResponse, isRecaptchaInvalid, validMLPayment, user, localAov, aov, onboarding, error_1, errorMsg, _a, sendcloud, e_1, e_2, err_1, message;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
            return __generator(this, function (_4) {
                switch (_4.label) {
                    case 0:
                        (0, generator_const_1._HideErrorMessage)();
                        return [4 /*yield*/, this.validateModule()];
                    case 1:
                        form = _4.sent();
                        console.log('send Form', form);
                        formData = form.data.customer;
                        formVal = (0, validate_const_1.checkCustomerData)(formData);
                        if (!formVal)
                            return [2 /*return*/, false];
                        if (!form.valid) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Please fill out all fields in all steps'));
                            return [2 /*return*/, false];
                        }
                        if (this.createCustomerLoading) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Still processing the membership creation, if the issue persists please refresh the page.'));
                            return [2 /*return*/, false];
                        }
                        hasMagiclinePaymentElement = (_b = magicline_payment_service_1.MagiclinePaymentService.isEnabledForStudio(this.config)) !== null && _b !== void 0 ? _b : (((_f = (_e = (_d = (_c = this.module) === null || _c === void 0 ? void 0 : _c.references) === null || _d === void 0 ? void 0 : _d.magiclinePaymentsElementRecuring) === null || _e === void 0 ? void 0 : _e.domElement) === null || _f === void 0 ? void 0 : _f.length) === 1 ||
                            ((_k = (_j = (_h = (_g = this.module) === null || _g === void 0 ? void 0 : _g.references) === null || _h === void 0 ? void 0 : _h.magiclinePaymentsElementUpfront) === null || _j === void 0 ? void 0 : _j.domElement) === null || _k === void 0 ? void 0 : _k.length) === 1);
                        hasNonSepaPaymentChoice = (0, input_output_helper_const_1._GetFieldDomObj)(input_mapping_const_1._PaymentChoice, this.$container).length > 0 &&
                            form.data.customer.paymentChoice !== 'DIRECT_DEBIT';
                        ignoredPaymentConsent = hasMagiclinePaymentElement || hasNonSepaPaymentChoice
                            ? (0, input_output_helper_const_1._GetFieldDomObj)(input_mapping_const_1._BankAccountMapping.consent, this.$container)
                            : undefined;
                        if (!(0, validate_dynamic_checkboxes_1.validateDynamicCheckboxes)(this.$container, ignoredPaymentConsent)) {
                            return [2 /*return*/, false]; // the function already shows the errors
                        }
                        if (!((_m = (_l = this.module.references.signField) === null || _l === void 0 ? void 0 : _l.domElement) === null || _m === void 0 ? void 0 : _m.length)) return [3 /*break*/, 4];
                        signFieldEl = document.querySelector('ci-sign-field');
                        return [4 /*yield*/, signFieldEl.getActiveDrawDuration()];
                    case 2:
                        time = _4.sent();
                        return [4 /*yield*/, signFieldEl.getCanvasData()];
                    case 3:
                        data = _4.sent();
                        console.log('validation for signature time', time);
                        if (time < 500) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Signature is required'));
                            return [2 /*return*/];
                        }
                        else {
                            form.data.signaturePng = data.imageData;
                            form.data.signatureSvg = data.imageSvgData;
                        }
                        _4.label = 4;
                    case 4:
                        recaptchaResponse = document.getElementById('g-recaptcha-response');
                        isRecaptchaInvalid = recaptchaResponse && recaptchaResponse.value.trim() === '';
                        console.log('Captcha invalid?', isRecaptchaInvalid);
                        if (isRecaptchaInvalid) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Please fill out the captcha'));
                            return [2 /*return*/, false];
                        }
                        validMLPayment = magicline_payment_service_1.MagiclinePaymentService.validateMagiclinePayments(this.config);
                        if (!validMLPayment.isValid) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Please enter your payment details'));
                            console.error('Payment validation failed', validMLPayment);
                            return [2 /*return*/, false];
                        }
                        this.createCustomerLoading = true;
                        (0, generator_const_1._CreateLoadingScreen)();
                        _4.label = 5;
                    case 5:
                        _4.trys.push([5, 25, , 26]);
                        user = form.data;
                        if ((_o = this.config.get) === null || _o === void 0 ? void 0 : _o.tenantKey) {
                            user.tenantKey = this.config.get.tenantKey;
                        }
                        if ((_p = this.config.get) === null || _p === void 0 ? void 0 : _p.fittecId) {
                            user.fittecId = this.config.get.fittecId;
                        }
                        if (user.contract) {
                            user.contract.notes = ((_r = (_q = user === null || user === void 0 ? void 0 : user.contract) === null || _q === void 0 ? void 0 : _q.notes) === null || _r === void 0 ? void 0 : _r.length)
                                ? user.contract.notes + ' ' + (0, notes_helper_const_1.getLocalStorageNotesString)()
                                : (0, notes_helper_const_1.getLocalStorageNotesString)();
                        }
                        localAov = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.rateBundleAOV);
                        aov = (0, aov_helper_const_1._ParseAOV)(localAov);
                        if (aov) {
                            user.aov = aov;
                        }
                        onboarding = undefined;
                        if (!(this.mlCreationWasSuccessful === false &&
                            ((((_s = this.stripePaymentElement) === null || _s === void 0 ? void 0 : _s.fitpayEnabled) && ((_t = this.stripePaymentElement) === null || _t === void 0 ? void 0 : _t.magiclinePaymentChoice) !== 'STRIPE') ||
                                !((_u = this.stripePaymentElement) === null || _u === void 0 ? void 0 : _u.fitpayEnabled)))) return [3 /*break*/, 10];
                        if (!(((_v = this.config.get) === null || _v === void 0 ? void 0 : _v.technologyType) !== 'none' || localStorage.getItem('membershipName') === 'DEMO BOX')) return [3 /*break*/, 9];
                        _4.label = 6;
                    case 6:
                        _4.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, (0, perform_onboarding_1._RegularOnboarding)(__assign(__assign({}, user), (this.guardian ? { guardian: this.guardian } : {})))];
                    case 7:
                        onboarding = _4.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        error_1 = _4.sent();
                        console.error('Failed onboarding', error_1);
                        errorMsg = getErrorMessage(error_1);
                        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(errorMsg !== null && errorMsg !== void 0 ? errorMsg : 'Contract creation failed.'));
                        if (!((_w = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.trim()) === null || _w === void 0 ? void 0 : _w.length)) {
                            (0, frontend_error_logger_service_1._LogFrontendError)(error_1, 'error');
                        }
                        this.createCustomerLoading = false;
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/];
                    case 9:
                        if (onboarding !== true) {
                            console.error('Error while onboarding');
                            this.createCustomerLoading = false;
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Onboarding failed'));
                            (0, generator_const_1._DeleteLoadingScreen)();
                            return [2 /*return*/];
                        }
                        else {
                            this.mlCreationWasSuccessful = true;
                        }
                        return [3 /*break*/, 12];
                    case 10:
                        if (!(((_x = this.stripePaymentElement) === null || _x === void 0 ? void 0 : _x.fitpayEnabled) && ((_y = this.stripePaymentElement) === null || _y === void 0 ? void 0 : _y.magiclinePaymentChoice) === 'STRIPE')) return [3 /*break*/, 12];
                        return [4 /*yield*/, (0, perform_onboarding_1._PerformFitpayPayment)(this.stripePaymentElement, __assign(__assign({}, user), (this.guardian ? { guardian: this.guardian } : {})))];
                    case 11:
                        //Perform stripe payment
                        // do the payment
                        onboarding = _4.sent();
                        this.createCustomerLoading = false;
                        _4.label = 12;
                    case 12:
                        if (onboarding !== true) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Onboarding failed'));
                            (0, generator_const_1._DeleteLoadingScreen)();
                            console.error('Error while onboarding', onboarding);
                            this.createCustomerLoading = false;
                            return [2 /*return*/];
                        }
                        if (!((_0 = (_z = this.config.get) === null || _z === void 0 ? void 0 : _z.receiverMail) === null || _0 === void 0 ? void 0 : _0.sendNewMemberEmail)) return [3 /*break*/, 16];
                        _4.label = 13;
                    case 13:
                        _4.trys.push([13, 15, , 16]);
                        return [4 /*yield*/, this.sendEmailService.sendEmail(this.config.get.receiverMail.sendNewMemberEmail, user, 'Vertragsabschluss')];
                    case 14:
                        _4.sent();
                        return [3 /*break*/, 16];
                    case 15:
                        _a = _4.sent();
                        return [3 /*break*/, 16];
                    case 16:
                        if (this.config.get.technologyType !== 'yond') {
                            this.finishLeads(); // dont await this, converting lead to member can fail and its fine
                        }
                        if (!((_2 = (_1 = this.config.get) === null || _1 === void 0 ? void 0 : _1.finish) === null || _2 === void 0 ? void 0 : _2.sendcloud)) return [3 /*break*/, 20];
                        _4.label = 17;
                    case 17:
                        _4.trys.push([17, 19, , 20]);
                        sendcloud = object_service_1.ObjectService.getInstance(sendcloud_welcomebox_1.SendcloudWelcomebox);
                        return [4 /*yield*/, sendcloud.sendToCustomer(user.customer)];
                    case 18:
                        _4.sent();
                        return [3 /*break*/, 20];
                    case 19:
                        e_1 = _4.sent();
                        console.error('some issue with sendcloud', e_1);
                        return [3 /*break*/, 20];
                    case 20:
                        _4.trys.push([20, 22, , 23]);
                        return [4 /*yield*/, this.trackerService.trackFunnelEvent(this.config, 'membershipCompleted')];
                    case 21:
                        _4.sent();
                        return [3 /*break*/, 23];
                    case 22:
                        e_2 = _4.sent();
                        console.error('membershipCompleted tracking failed', e_2);
                        return [3 /*break*/, 23];
                    case 23:
                        //have to remove the uuid in case a new member creates membership with THIS device
                        this.leadService.hardNewLeadUUID();
                        return [4 /*yield*/, this.clickWebflowButton()];
                    case 24:
                        _4.sent();
                        return [3 /*break*/, 26];
                    case 25:
                        err_1 = _4.sent();
                        message = (_3 = getErrorMessage(err_1)) !== null && _3 !== void 0 ? _3 : 'Failed sending form';
                        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(message));
                        (0, frontend_error_logger_service_1._LogFrontendError)(err_1, 'error');
                        console.error('send form error', err_1);
                        return [3 /*break*/, 26];
                    case 26:
                        this.createCustomerLoading = false;
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    Form.prototype.clickWebflowButton = function () {
        return __awaiter(this, void 0, void 0, function () {
            var form, submitButton, webflowButton;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return __generator(this, function (_q) {
                // send event membership completed
                this.communicationService.sendEvent({
                    event: 'custom',
                    module: this,
                    name: 'membershipCompleted',
                    value: true,
                });
                // check for optional lead form, if it exists, submit it too
                if (((_c = (_b = (_a = this.module) === null || _a === void 0 ? void 0 : _a.references) === null || _b === void 0 ? void 0 : _b.leadForm) === null || _c === void 0 ? void 0 : _c.domElement) && !((_f = (_e = (_d = this.config) === null || _d === void 0 ? void 0 : _d.get) === null || _e === void 0 ? void 0 : _e.leadForm) === null || _f === void 0 ? void 0 : _f.skipFormSubmission)) {
                    try {
                        form = this.module.references.leadForm.domElement[0];
                        form.submit();
                    }
                    catch (e) {
                        console.error('found a lead form, but cant submit it', e);
                    }
                }
                if ((_j = (_h = (_g = this.config) === null || _g === void 0 ? void 0 : _g.get) === null || _h === void 0 ? void 0 : _h.finish) === null || _j === void 0 ? void 0 : _j.skipFormSubmission) {
                    this.createCustomerLoading = false;
                    (0, generator_const_1._DeleteLoadingScreen)();
                    localStorage.removeItem('leaduuid');
                    if ((_l = (_k = this.config) === null || _k === void 0 ? void 0 : _k.get) === null || _l === void 0 ? void 0 : _l.redirect) {
                        window.location.href = this.config.get.redirect;
                    }
                    else {
                        console.warn('Form submission was disabled, but no redirect was set, so nothing happens');
                    }
                    return [2 /*return*/];
                }
                submitButton = (_o = (_m = this.module.references) === null || _m === void 0 ? void 0 : _m.webflowSubmit) === null || _o === void 0 ? void 0 : _o.domElement;
                // legacy ID support
                if (!(submitButton === null || submitButton === void 0 ? void 0 : submitButton.length)) {
                    submitButton = this.$container.find(form_const_1.MAPPINGS.webflowSubmitButton.id);
                }
                if (!(submitButton === null || submitButton === void 0 ? void 0 : submitButton.length)) {
                    webflowButton = (0, cash_dom_1.default)('<input>').attr({
                        type: 'submit',
                        class: 'w-button',
                        'data-action': 'webflowSubmit',
                        id: form_const_1.MAPPINGS.webflowSubmitButton.id,
                    });
                    this.$container.find('[data-action="submit"]').append(webflowButton);
                }
                // enable form submit again
                if (((_p = this.membershipFormElement) === null || _p === void 0 ? void 0 : _p.length) > 0) {
                    (0, input_output_helper_const_1._EnableFormSubmit)(this.membershipFormElement);
                }
                if (!(submitButton === null || submitButton === void 0 ? void 0 : submitButton.length)) {
                    submitButton = this.$container.find('[data-action="webflowSubmit"]');
                }
                this.createCustomerLoading = false;
                (0, generator_const_1._DeleteLoadingScreen)();
                localStorage.removeItem('leaduuid');
                console.log('clicking webflow submit button:', submitButton[0]);
                submitButton[0].click();
                return [2 /*return*/];
            });
        });
    };
    Form.prototype.disableHiddenFields = function () {
        var _this = this;
        var hiddenFields = Object.values(form_const_1.MAPPINGS).filter(function (a) { return a.disabled; });
        hiddenFields.forEach(function (a) { return _this.$container.find(a.id).prop('disabled', true); });
    };
    Form.prototype.finishLeads = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3, manyChatApi, leadResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.leadService.finishLead()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        console.error('Error finishing lead - ignored (member > lead)', e_3);
                        return [3 /*break*/, 3];
                    case 3:
                        if (!localStorage.getItem('manychat-lead-id')) return [3 /*break*/, 5];
                        manyChatApi = object_service_1.ObjectService.getInstance(manychat_api_1.ManyChatApi);
                        return [4 /*yield*/, manyChatApi.finishLeadInManyChat({
                                id: localStorage.getItem('manychat-lead-id'),
                                tenantId: this.config.get.tenantKey,
                                contract: true,
                            })];
                    case 4:
                        leadResponse = _a.sent();
                        if ((leadResponse === null || leadResponse === void 0 ? void 0 : leadResponse.success) && (leadResponse === null || leadResponse === void 0 ? void 0 : leadResponse.id)) {
                            localStorage.removeItem('manychat-lead-id');
                        }
                        else if (leadResponse.error) {
                            // _ShowErrorMessage(leadResponse.error);
                        }
                        console.error(leadResponse);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return Form;
}());
exports.Form = Form;
function getErrorMessage(error) {
    if (error instanceof Error)
        return error.message;
    if (error && typeof error === 'object' && 'message' in error) {
        var message = error.message;
        return typeof message === 'string' ? message : undefined;
    }
    if (error && typeof error === 'object' && 'error' in error) {
        var message = error.error;
        return typeof message === 'string' ? message : undefined;
    }
    return undefined;
}
